import { 
	createSlice,
	createAsyncThunk
} from '@reduxjs/toolkit'
import { envAwarePost} from '../../util/util'

export const getProgressPictures = createAsyncThunk(
	'getProgressPictures',
	async payload => envAwarePost('api/pictures/',{action:'fetchProgressPictures',...payload})
)

export const getComparisonPictures = createAsyncThunk(
	'getComparisonPictures',
	async payload => envAwarePost('api/pictures/',{action:'fetchComparisonPictures',...payload})
)

export const editProgressPicture = createAsyncThunk(
	'editProgressPicture',
	async (payload) => envAwarePost('api/pictures/',{
		action:'editProgressPicture',
		...payload
	})
)

export const deleteProgressPicture = createAsyncThunk(
	'deleteProgressPicture',
	async (id) => envAwarePost('api/pictures/',{
		action: 'deleteProgressPicture',
		id
	})
)

export const deleteComparisonPicture = createAsyncThunk(
	'deleteComparisonPicture',
	async (id) => envAwarePost('api/pictures/',{
		action: 'deleteComparisonPicture',
		id
	})
)

const picuturesSlice = createSlice({
	name: 'pictures',
	initialState:{pics:[],comparisonPics:[]},
	reducers: {},
	extraReducers:{
		[getProgressPictures.fulfilled] : (state,action)=>{
			const {success,data} = action.payload
			if(success == 1){
				state.pics = data.pics
			}
		},
		[getComparisonPictures.fulfilled] : (state,action)=>{
			const {success,data} = action.payload
			if(success == 1){
				state.comparisonPics = data.pics
			}
		},
		[editProgressPicture.fulfilled] : (state, action) => {
			const {id,update} = action.meta.arg
			const specifiedPic = state.pics.find(pic => pic.pic_id == id);
			specifiedPic.date = update.date;
			specifiedPic.caption = update.caption;
		},
		[deleteProgressPicture.fulfilled] : (state, action) => {
			state.pics = state.pics.filter(pic => pic.pic_id != action.meta.arg);
		},
		[deleteComparisonPicture.fulfilled] : (state, action) => {
			state.comparisonPics = state.comparisonPics.filter(pic => pic.comparisonPic_id != action.meta.arg);
		}
	}
})


export default picuturesSlice.reducer